// src/components/notifications/NotificationActionMenu.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  MarkEmailRead as MarkReadIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';

export default function NotificationActionMenu({
  anchorEl,
  notification,
  onClose,
  onMarkAsRead,
  onDelete,
}) {
  const { t } = useTranslation();
  const isOpen = Boolean(anchorEl);

  const handleMarkAsRead = () => {
    onMarkAsRead();
    onClose();
  };

  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
    >
      {notification && !notification.is_read && (
        <MenuItem onClick={handleMarkAsRead}>
          <ListItemIcon>
            <MarkReadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{t('notifications:action_menu.mark_as_read')}</ListItemText>
        </MenuItem>
      )}
      <MenuItem onClick={handleDelete}>
        <ListItemIcon>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t('notifications:action_menu.delete')}</ListItemText>
      </MenuItem>
    </Menu>
  );
}